module.exports = __webpack_public_path__ + "img/hero-education.472b9bd.svg";